import { Popup } from 'devextreme-react/popup'
import React, { FC} from 'react'
import { RecapPopupContent } from './recap-popup-content'
import './recap-popup.scss'

type Props = {
    visible: boolean,
    tripId: number | undefined,
    stopId: number | undefined,
    isNavFromStopOverview: boolean,
    onClickCancel: () => void,
}

export const RecapPopup: FC<Props> = ({ visible, tripId, stopId, isNavFromStopOverview, onClickCancel }) => {
    
    return (
        <Popup
            visible={visible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={325}
            height={'auto'}
        >
           <RecapPopupContent tripId={tripId} stopId={stopId} isNavFromStopOverview={isNavFromStopOverview} onClickCancel={onClickCancel}/>
        </Popup>
    )
}